import { MB_CONFIG } from '../config'

export default {

    getAll: () => axios.get(MB_CONFIG.API_URL + '/clients/all'),

    refresh: (lastUpdate) => lastUpdate ? axios.get(MB_CONFIG.API_URL + '/clients/refresh/' + lastUpdate) : axios.get(MB_CONFIG.API_URL + '/clients/all'),

    getClient: (clientID) => axios.get(MB_CONFIG.API_URL + '/clients/' + clientID),

    deleteClient: (clientID) => axios.delete(MB_CONFIG.API_URL + '/clients/' + clientID),

    postClient: (client) => axios.post(MB_CONFIG.API_URL + '/clients', client),

    putClient: (clientID, client) => axios.put(MB_CONFIG.API_URL + '/clients/' + clientID, client),

    save: (client) => client.id ? axios.put(MB_CONFIG.API_URL + '/clients/' + client.id, client) : axios.post(MB_CONFIG.API_URL + '/clients', client)

}
